module.exports = {"baseUrl":"https://api.aircheckr.com"};


// WEBPACK FOOTER //
// external "{/"baseUrl/":/"https:/api.aircheckr.com/"}"